import React from 'react';
import { StyleSheet } from 'react-native';
import Column from 'src/components/10-atoms/layout/Column';
import ThumbnailContainer from './ThumbnailContainer';
const PDFThumbnail = ({ src, ...thumbnailContainerProps }) => {
    return (React.createElement(ThumbnailContainer, { src: src, ...thumbnailContainerProps }, src && (React.createElement(Column, null,
        React.createElement("object", { data: src, type: "application/pdf", width: "100%", height: "100%" }),
        React.createElement(Column, { style: StyleSheet.absoluteFill })))));
};
export default PDFThumbnail;
